import React, { useEffect } from "react";
import useSelection from "hooks/useSelection";
import useBookings from "hooks/useBookings";
import { useHistory } from "react-router-dom";

const Creation = () => {
  const history = useHistory();
  const { clearBooking, submitSelection } = useSelection({});

  useEffect(() => {
    createNewBooking();
  }, []);

  const createNewBooking = async () => {
    clearBooking();
    await submitSelection();
    history.push("/where");
  };
};

export default Creation;
